import React, { useEffect, useState } from "react";
import SvgIcon from "../../../Components/Common/Component/SvgIcon";
import {
  CHECKALL,
  DeliveryComplete,
  DeliveryProcessing,
  Notification,
  OrderComplete,
  TicketsGenerated,
} from "../../../Constant";
import {
  ChangeInStatus,
  ChangeStatus,
  InquiryList,
  loginuserdata,
  NotificationList,
  ChangeStatusOp,
  OpInquiry
} from "../../../apiController";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import {UL, LI, H6} from '../../../AbstractElements'

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [inquiryList, setInquiryList] = useState([]);
  
  const userId = loginuserdata.user.id;
  const [opInquiryList, setOpInquiryList] = useState([]);

  useEffect(() => {
    fetchNotificationList(userId);
    fetchInquiryList(userId);
    // fetchOpInquiryList(userId);
  }, []);

  const fetchNotificationList = async (id) => {
    try {
      const response = await NotificationList({
        role: "staff_status",
        id: id,
      });
      if (response) {
        const notification = response.notifications;
        setNotificationList(notification);
        console.log(notification);
      }
    } catch (error) {
      toast.error("An error occurred during login", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const fetchInquiryList = async (id) => {
    try {
      const response = await InquiryList({
        role: "staff_status",
        id: id,
      });
      if (response) {
        const notification = response.notifications;
        setInquiryList(notification);
      }
    } catch (error) {
      toast.error("An error occurred during login", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  // const fetchOpInquiryList = async (id) => {
  //   try {
  //     const response = await OpInquiry({
  //       role: "staff_status",
  //       id: id,
  //     });
  //     if (response) {
  //       const notification = response.notifications;
  //       setOpInquiryList(notification);
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred during login", {
  //       position: toast.POSITION.TOP_CENTER,
  //     });
  //   }
  // };

  const handleStatus = () => {
    changeStatus(userId);
  };

  const changeStatus = async (id) => {
    try {
      const response = await ChangeStatus({
        role: "staff_status",
        id: id,
      });
      if (response.status === true) {
        toast.success("Status Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred during login", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchNotificationList(userId);
    }
  };
  const handleInquiryStatus = () => {
    changeInStatus(userId)
  }
  
  
  const changeInStatus = async (id) => {
    try {
      const response = await ChangeInStatus({
        role: "doctor_status",
        id: id,
      });
      if (response.status === true) {
        toast.success("Status Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred during login", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchInquiryList(userId);
    }
  };

  // const handleOpStatus = () => {
  //   changeOpStatus(userId);
  // };
  // const changeOpStatus = async (id) => {
  //   try {
  //     const response = await ChangeStatusOp({
  //       role: "staff_status",
  //       id: id,
  //     });
  //     if (response.status === true) {
  //       toast.success("Status Updated Successfully!", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //     }
  //   } catch (error) {
  //     toast.error("An error occurred during login", {
  //       position: toast.POSITION.TOP_CENTER,
  //     });
  //   } finally {
  //     fetchInquiryList(id);
  //   }
  // };

  return (
    <li className="onhover-dropdown">
      <div
        className="notification-box"
        onClick={() => setNotificationDropDown(!notificationDropDown)}
      >
        <SvgIcon iconId="notification" />
        <span className="badge rounded-pill badge-secondary">{notificationList?.length || inquiryList?.length }</span>
      </div>
      <div
        className={`notification-dropdown onhover-show-div ${
          notificationDropDown ? "active" : ""
        }`}
      >
        <h6 className="f-18 mb-0 dropdown-title">{Notification}</h6>
        <ul>
          <span className="f-12 mb-0 dropdown-title d-flex align-items-center">
            <p className="m-0">{"A new patient has been Registered"}</p>{" "}
            <Button
              className="border-0 m-0 p-0 text-primary"
              color="none"
              onClick={handleStatus}
            >
              {"Mark as Read"}
            </Button>{" "}
          </span>
          {notificationList.length > 0 ?
            notificationList.map((note, index) => (
              <li
                key={index}
                className={`border-4 ${
                  index % 2 === 0 ? "b-l-primary" : "b-l-success"
                }`}
              >
                <p>
                  {index + 1}.{`${note.first_name} ${note.surname}`}{" "}
                  <span className="font-danger">{note.phone}</span>
                </p>
              </li>
            )) : 'No data Available'}
        </ul>
        <ul>
          <span className="f-12 mb-0 dropdown-title d-flex align-items-center justify-content-between">
            <p className="m-0">{"Patient Inquired for Appointment"}</p>{" "}
            <Button
              className="border-0 m-0 p-0 text-primary"
              color="none"
              onClick={handleInquiryStatus}
            >
              {"Mark as Read"}
            </Button>{" "}
          </span>
          {inquiryList.length > 0 ?
            inquiryList.map((note, index) => (
              <li
                key={index}
                className={`border-4 ${
                  index % 2 === 0 ? "b-l-primary" : "b-l-success"
                }`}
              >
               
                  <p className="d-flex justify-content-between">
                    {index + 1}.{`${note.first_name} ${note.surname}  `}{" "}
                    <span className="font-danger">{note.phone}</span>
                  {/* <span>{note.date}</span> */}
                  </p>
              </li>
            )) : 'No data Available'}
        </ul>
        {/* <ul>
          <span className="f-12 mb-0 dropdown-title d-flex align-items-center justify-content-between">
            <p className="m-0">{"Out Patient Inquired for Appointment"}</p>{" "}
            <Button
              className="border-0 m-0 p-0 text-primary"
              color="none"
              onClick={handleOpStatus}
            >
              {"Mark as Read"}
            </Button>{" "}
          </span>
          {opInquiryList.length > 0 ?
            opInquiryList.map((note, index) => (
              <li
                key={index}
                className={`border-4 ${
                  index % 2 === 0 ? "b-l-primary" : "b-l-success"
                }`}
              >
               
                  <p className="d-flex justify-content-between">
                    {index + 1}.{`${note.patient_name} `}{" "}
                    <span className="font-danger">{note.phone}</span>
                  </p>
              </li>
            )) : 'No data Available'}
        </ul> */}

        {/* <ul>
          <li className='b-l-primary border-4'>
            <p>
              {DeliveryProcessing} <span className='font-danger'>{'10 min.'}</span>
            </p>
          </li>
          <li className='b-l-success border-4'>
            <p>
              {OrderComplete}
              <span className='font-success'>{'1 hr'}</span>
            </p>
          </li>
          <li className='b-l-info border-4'>
            <p>
              {TicketsGenerated}
              <span className='font-info'>{'3 hr'}</span>
            </p>
          </li>
          <li className='b-l-warning border-4'>
            <p>
              {DeliveryComplete}
              <span className='font-warning'>{'6 hr'}</span>
            </p>
          </li>
          <li>
            <a className='f-w-700' href='#javascript'>
              {CHECKALL}
            </a>
          </li>
        </ul> */}
      </div>
    </li>
  );
};

export default Notificationbar;
